<template>
  <div class="commodity-list">
    <div v-for="(item,index) of auctionList" :key="index" class="commodity-content">
      <div class="title">
        <h1>
          <img alt="" class="img1" src="@/assets/imgs/match/店铺@2x.png">
          <span style="font-weight: bolder">{{ item.sellerName }}</span>
          <img alt="" class="img2" src="@/assets/imgs/match/更多@2x.png">
        </h1>
        <div>
          {{ selectEle.auModeList[item.auMode] }}
        </div>
      </div>
      <div class="content" @click="linkToDetail(item)">
        <div class="content-left">
          <div class="content-left-top">
            <img :src="item.image" class="big-img"/>
            <img class="show-img" src="@/assets/imgs/auction/编组@2x.png" v-if="item.resultsWay === '00'"/>
          </div>
          <div class="content-left-bottom">
            <template v-if="item.status === '40'">
              <img alt="" class="min-img" src="@/assets/imgs/auction/flash-bidding.png">
              <span class="bidding"><van-count-down :time="countDown(item)" format="DD天HH:mm:ss" /></span>
            </template>
            <template v-else>
              <img alt="" class="min-img" src="@/assets/imgs/auction/路径@2x(2).png">
              <span>{{ item.buttonStatus.statusText }}</span>
            </template>
          </div>
        </div>
        <div class="content-right">
          <h1  style="font-weight: bolder">
            <span class="bidding" v-if="item.status === '40'">竞拍中</span>{{ item.auTitle }} {{ item.auCode }} {{ item.description }}
          </h1>
          <div class="price" style="font-weight: bolder">起拍价：<span>￥</span><span style="font-size: 24px;">{{ item.priceGrade }}</span></div>
          <div>
            <span>竞拍量：{{ $utils.emptyFormat(item.quantity) }}{{ item.measureUnit }}</span>
            &nbsp;
            <span>起拍量：{{ item.quantity }}{{ item.measureUnit }}</span>
          </div>
          <div>{{ item.validBeginTime | dateFilter('time') }} 至 {{ item.finalEndTime | dateFilter('time') }}</div>
          <div class="aprove-button">
            <div class="text-underline" @click.stop="lookNotice(item)" v-if="item.status !== '60'" >查看公告 ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {auctionImg} from "@/views/auction/auction-utils";

export default {
  name: "auctionList",
  props: ["auctionList"],
  data() {
    return {
      auctionImg: auctionImg,
      LNGmaterialCode: this.$common.interfacePath.LngMaterialCode,
      PNGmaterialCode: this.$common.interfacePath.PngMaterialCode,
      selectEle: {
        auctionStatusList: [
          {name: "即将开始", key: "toBegin"},
          {name: "正在竞拍", key: "inProgress"},
          {name: "已结束", key: "completed"},
          {name: "我参与的", key: "myIntent"},
        ],
        auModeList: {
          10: "最低价成交",
          20: "出价成交",
        },
        dissussWayList: {
          10: "公开报价",
          20: "封闭报价",
        },
        statusTextList: {
          30: "即将开始",
          40: "正在进行",
          50: "已结束",
          60: "已结束",
        },
      },
    };
  },
  computed: {
    curTime() {
      return new Date().getTime();
    },
  },
  methods: {
    auctionLink() {
      this.$toast('请到电脑端参与竞拍');
    },
    // 详情
    linkToDetail(item) {
      this.$router.push(`/auction-detail?auId=${item.auId}`);
    },
    // 查看公告
    lookNotice(item) {
      this.$router.push(`/auction-notice?auId=${item.auId}`);
    },
    countDown(item){
      return new Date(item.finalEndTime).getTime() - new Date().getTime()
    }
  },
};
</script>

<style lang='stylus' scoped>
.commodity-list {
  padding: 0 32px;
}

.commodity-content {
  box-sizing: border-box;
  width: 100%;
  padding: 32px;
  margin: 32px 0;
  border-radius: 16px 16px 16px 16px;
  background: #fff;

  .title {
    display: flex;
    justify-content: space-between;

    h1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;

      span {
        margin: 0 6px;
      }

      .img1 {
        width: 32px;
        height: 32px;
        vertical-align: top;
      }

      .img2 {
        width: 24px;
        height: 24px;
        vertical-align: baseline;
      }
    }

    div {
      width: 128px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      background: rgba(95, 132, 219, 0.1);
      border-radius: 4px 4px 4px 4px;
      border: 1px solid rgba(95, 132, 219, 0.5);
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #5F84DB;
    }
  }

  .content {
    margin-top: 24px;
    display: flex;

    .content-left {
      .content-left-top {
        position: relative;

        .big-img {
          width: 176px;
          height: 176px;
        }

        .show-img {
          position: absolute;
          top: 8px;
          left: 8px;
          width: 146.2px;
          height: 146.2px;
        }
      }

      .content-left-bottom {
        position: relative;

        .min-img {
          position: absolute;
          top: 20px;
          left: 0;
          width: 23.38px;
          height: 40px;
        }

        span {
          top -8px
          position: relative;
          margin-left: 4px;
          box-sizing: border-box;
          display: inline-block;
          width: 173px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background: rgba(0, 0, 0, 0.06);
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 20px;
          color: #999999;

          .van-count-down{
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 20px !important;
            color: #E0000C !important;
            line-height: 36px !important;
          }
        }

        .bidding{
          background rgba(242,39,24,0.06)
        }
      }
    }

    .content-right {
      margin-left: 20px;

      .bidding {
        background: #E0000C;
        border-radius: 5px;
        padding 2px 4px
        margin-right 10px
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #FFFFFF;
      }
      // line-height: 27px;

      > div {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #666666;
        line-height: 28px;
      }

      > div:last-of-type {
        font-size: 20px;
        margin-top: 8px;
      }

      h1 {
        font-weight: 500;
        font-size: 28px;
        color: #333333;
        line-height: 33px;
      }

      .price {
        margin: 32px 0 12px;
        font-weight: 500;
        font-size: 24px;
        color: #333333;

        span {
          color: #FF5500;
        }
      }

      .aprove-button{
        height: 34px;
        margin-top 20px !important
        .text-underline{
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 24px !important;
          color: #333333;
        }
      }
    }
  }
}

#commodity-list {
  overflow: auto;
  flex: 1;

  .commodity-content {
    padding-top: 15px;
    padding-bottom: 15px;

    .commodity-foreach {
      font-size: 24px;
      padding: 15px 55px 15px 24px;
      display: flex;
      margin-bottom: 4px;
      flex-direction: column;
      background: #fff;

      .conent-position {
        display: flex;
        justify-content: space-between;

        .img-wrap {
          padding: 5px 0 5px 8px;

          .bid-img {
            width: 122.47px;
            height: 122.47px;
          }
        }
      }

      .content-bottom {
        .bottom-line {
          font-size: 24px;
          font-weight: 400;
          display: flex;
          justify-content: space-between;
          line-height: 45px;
          height: 45px;

          .label-strong {
            font-weight: bold;
            font-size: 26px;
          }

          .red {
            color: #E12020;
          }
        }

        .aprove-button {
          display: flex;
          padding: 20px;
          justify-content: space-around;

          .text-underline {
            color: #57a3f3;
            text-decoration: underline;
            width: 130px;
            height: 40px;
            line-height: 40px;
            margin-right: 30px;
          }

          /deep/ .van-button {
            width: 130px;
            height: 40px;
            line-height: 40px;
            // margin-left: 20px;
          }
        }

        .bottom-height {
          border-top: 1px solid #E3E3E3;
          display: flex;
          align-items: center;
          height: 80px;
        }
      }

      .content-line {
        font-size: 24px;
        font-weight: 400;
        display: flex;
        align-items: center;
        height: 44px;

        .tag {
          margin-right: 5px;
          width: 84px;
          height: 30px;
          background: #FFFFFF;
          border: 1px solid #E12020;
          opacity: 1;
          border-radius: 4px;
          font-size: 20px;
          line-height: 30px;
          color: #E12020;
          text-align: center;
        }

        .location {
          display: flex;
          align-items: center;

          .location-img {
            width: 16px;
            height: 20px;
            margin-right: 5px;
          }
        }

        .label {
          margin-right: 5px;
        }

        .line {
          margin: 0 5px;
        }

        .price {
          font-size: 40px;
          color: #E12020;
        }

        .red {
          color: #E12020;
        }

        .count-dowm-wrap {
          display: flex;
          width: 468px;
          height: 33px;
          background: #F3F3F3;
          opacity: 1;
          border-radius: 4px;

          .status {
            width: 108px;
            background: #E12020;
            border-radius: 4px 16px 16px 4px;
            line-height: 33px;
            color: #FFFFFF;
            text-align: center;
          }

          .end-status { // 已结束
            background: #828999;
          }

          .count-down {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            line-height: 33px;
            color: #333333;
            text-align: center;
          }
        }
      }

      .content-top {
        display: flex;

        .content-left {
          height: 214px;

          img {
            width: 214px;
            height: 214px;
            border-radius: 10px;
          }
        }

        .content-right {
          height: 214px;
          padding-left: 20px;
          padding-bottom: 10px;
          color: rgba(51, 51, 51, 1);
          line-height: 44px;
          flex: 1;
          display: flex;
          flex-direction: column;

          span {
            font-weight: 300;
            color: rgba(153, 153, 153, 1);
          }

          .content-title {
            font-size: 28px;
            font-weight: 400;
            display: flex;
            align-items: center;

            .circle-icon {
              width: 40px;
              height: 40px;
              display: flex;
              align-items: center;
              align-content: center;
              justify-content: center;
              border-radius: 50%;
              background: #E12020;
              color: #fff;
              margin-left: 10px;
              font-size: 20px;
            }

            .tag {
              margin-right: 5px;

              img {
                width: 26px;
                height: 30.86px;
              }
            }
          }

          .aprove-button{
            .text-underline{
              height 30px
            }
          }
        }
      }
    }
  }
}
</style>
